export default function WhyChooseUs() {
  const images = [
    {
      url: 'https://public.readdy.ai/ai/img_res/93c14c95209cbe9a43b47736b1e1a6f1.jpg',
      alt: 'Elegant modern living room interior in Granada and Costa del Sol property',
      title: 'Granada and Costa del Sol Real Estate - Modern Living Room Design'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Luxury%20property%20entrance%20hall%20with%20marble%20flooring%2C%20modern%20chandelier%2C%20elegant%20staircase%2C%20high-end%20residential%20interior%2C%20sophisticated%20design%20elements%2C%20warm%20ambient%20lighting%2C%20professional%20real%20estate%20photography&width=600&height=400&seq=interior-002&orientation=landscape',
      alt: 'Luxury property entrance hall with elegant design',
      title: 'Granada and Costa del Sol Property Management - Luxury Entrance Hall'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Contemporary%20kitchen%20with%20sleek%20cabinetry%2C%20modern%20appliances%2C%20marble%20countertops%2C%20minimalist%20design%2C%20bright%20and%20airy%20space%2C%20professional%20interior%20design%2C%20high-end%20residential%20property&width=600&height=400&seq=interior-003&orientation=landscape',
      alt: 'Contemporary kitchen with modern design in Granada and Costa del Sol',
      title: 'Granada and Costa del Sol Real Estate Services - Modern Kitchen Design'
    }
  ];

  return (
    <section id="about" className="py-24 bg-amber-50/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-4">
            {images.map((img, index) => (
              <div key={index} className="w-full h-64 overflow-hidden rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 hover:scale-[1.02]">
                <img 
                  src={img.url}
                  alt={img.alt}
                  title={img.title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            ))}
          </div>

          <div className="lg:pl-12">
            <p className="text-xs font-semibold text-teal-600 uppercase tracking-widest mb-4">
              Why Choose Us
            </p>
            <h3 className="font-['Playfair_Display'] text-4xl font-bold text-gray-900 mb-6 leading-tight">
              Comprehensive <strong>Real Estate Solutions</strong> Across <strong>Granada and Costa del Sol</strong>
            </h3>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              <strong>Excl Projects SL</strong> is your trusted partner for all <strong>real estate needs in Granada and Costa del Sol, Spain</strong>. We offer a complete range of services from <strong>property search</strong> and <strong>purchase guidance</strong> to professional <strong>property management</strong> and interior design solutions. Our comprehensive <strong>real estate services</strong> ensure every aspect of your property journey is handled with expertise.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Our team combines deep local <strong>Granada and Costa del Sol real estate</strong> market knowledge with professional expertise in <strong>real estate services</strong>, business consultancy, and computer facilities management to deliver exceptional results for our clients. Whether you're looking for <strong>property management in Granada and Costa del Sol</strong> or comprehensive <strong>real estate consultancy</strong>, we provide tailored solutions.
            </p>

            <div className="grid grid-cols-3 gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-teal-600 mb-1">68.32</div>
                <div className="text-xs text-gray-600 uppercase tracking-wide">CNAE Licensed</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-teal-600 mb-1">B22910665</div>
                <div className="text-xs text-gray-600 uppercase tracking-wide">Registered Company</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-teal-600 mb-1">Local</div>
                <div className="text-xs text-gray-600 uppercase tracking-wide">Expertise</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
